import { put as apiPut, TYPE_BROOKLYN_JSON } from 'api-client'
import _assign from 'lodash/assign'
import _cloneDeep from 'lodash/cloneDeep'
import _get from 'lodash/get'

export const UPDATE_PAYMENT_ERROR_TYPE_POSTAL_CODE = 'POSTAL_CODE_ERROR'

const SCHEMA_UPDATE_PAYMENT_METHOD = {
  _dataError: null,
  success: null,
  data: null,
}

const SCHEMA_UPDATE_PAYMENT_METHOD_ERROR = {
  _dataError: null,
  success: false,
}

export async function updatePaymentMethod (options) {
  const { auth } = options
  const update = formatPaymentMethod(options)
  try {
    const res = await apiPut('v1/billing/account/payment-method', update, { auth }, TYPE_BROOKLYN_JSON)
    return handleUpdatePaymentMethod(res)
  } catch (err) {
    return handleUpdatePaymentMethodError({}, true)
  }
}

function handleUpdatePaymentMethod (res, _dataError) {
  const data = _get(res, 'body', {})

  return _assign(_cloneDeep(SCHEMA_UPDATE_PAYMENT_METHOD), {
    _dataError,
    success: _get(data, 'success'),
    data,
  })
}

function handleUpdatePaymentMethodError (res, _dataError) {
  return _assign(_cloneDeep(SCHEMA_UPDATE_PAYMENT_METHOD_ERROR), {
    _dataError,
    success: false,
  })
}

/**
 * Format a payment method update
 */
export function formatPaymentMethod (options) {
  const {
    adyen,
    country,
    postalCode,
  } = options
  const paymentUpdateData = {
    country,
    postalCode,
    adyen,
  }

  return paymentUpdateData
}
